//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useContext } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

//custom pages
import "assets/css/custom.css";
import useForm from "helpers/useForm";
import { forgotPasswordValidate } from "helpers/validateRules/auth";
import auth from "apis/auth/auth";
import LoginParent from "components/AuthPages/LoginParent";
import { forgotPasswordStyles } from "./styles";
import Context from "context/context";
import Loader from "components/Loader/Loader";

// material-ui
import {
  ThemeProvider,
  withStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import MenuItem from "@material-ui/core/MenuItem";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#fff",
    },
    "& .MuiInputBase-input": {
      color: "#fff",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#fff",
      },
      "&:hover fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff",
      },
    },
  },
})(TextField);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

const org = [
  {
    value: "Henry Schein Dental",
    label: "Henry Schein Dental",
  },
  {
    value: "Henry Schein Canada",
    label: "Henry Schein Canada",
  },
];

const toastCss = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
};

const initialValues = {
  email: "",
  org: ""
};

export default function ForgotPassword() {
  const history = useHistory();
  const { state, dispatch } = useContext(Context);
  const { forgotPassword } = auth();

  const classes = forgotPasswordStyles();

  const [states, setstates] = useState({});

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // handling inputs
  const { values, errors, handleSubmit, handleChange, setUpdateValue } =
    useForm(initialValues, handleForgotPassword, forgotPasswordValidate);

  // forgot password api func
  async function handleForgotPassword() {
    dispatch({ type: "SET_LOADING", payload: true });
    let res = await forgotPassword(values);
    dispatch({ type: "SET_LOADING", payload: false });
    if (res && res.type == "success") {
      return history.push("/verify-otp", {
        emailResponse: { ...res },
      });
    }
    toast.error(res && res.message ? res.message : "something went wrong", { toastId: "forgotPasswordError" });
    setStates({ disableButton: false });
  }

  const clearError = (key) => {
    if (errors?.[key]) {
      delete errors[key];
    }
    return;
  };

  return (
    <LoginParent>
      <div className={classes.forgotPasswordText}>
        <ArrowBackOutlinedIcon
          className={classes.arrowBtn}
          onClick={() => {
            history.push("/login");
          }}
        />
        <br />
        Create, Reset or Forgot Password
      </div>
      <div className={classes.inputMainDiv}>
        <ThemeProvider theme={formLabelsTheme}>
          <Loader Loading={state.loading}>
            <CssTextField
              id="emailId"
              label="Email ID"
              type={"email"}
              autoComplete="off"
              required
              fullWidth={true}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip
                      arrow
                      placement="top-start"
                      title="Enter the Email Id for resetting password"
                    >
                      <IconButton className={classes.inputIconBtn}>
                        <InfoOutlinedIcon className={classes.inputIcon} />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              value={values.email}
              onChange={(e) => {
                handleChange({ name: "email", value: e.target.value });
              }}
            />
          </Loader>
        </ThemeProvider>
        {errors.email && <span className="error">{errors.email}</span>}
      </div>
      <br />
      <div className={classes.inputMainDiv}>
        <ThemeProvider theme={formLabelsTheme}>
          <Loader Loading={state.loading}>
            <CssTextField
              id={"organization"}
              label={"Organization"}
              select
              fullWidth
              type={"text"}
              value={values.org}
              onChange={(e) => {
                handleChange({ name: "org", value: e.target.value });
                clearError("org");
              }}
            >
              {org.map((o, i) => (
                <MenuItem value={o.value} key={i}>
                  {o.label}
                </MenuItem>
              ))}
            </CssTextField>

          </Loader>
        </ThemeProvider>
        {errors.org && <span className="error">{errors.org}</span>}
      </div>
      <div className={classes.btnDiv}>
        <Button
          variant="contained"
          className={classes.btn}
          onClick={() => {
            handleSubmit();
            setStates({ disableButton: true });
          }}
        >
          Send OTP
        </Button>
      </div>
    </LoginParent>
  );
}
